import { create } from 'zustand'

import type { HairSalonScheduledTask, HairSalonTask } from '@monorepo/functions/src/types/reservations'

import type { CalendarState, CalendarView } from './types'

interface CalendarStore extends CalendarState {
    isLoading: boolean
    setIsLoading: (isLoading: boolean) => void
    setSelectedTask: (task: HairSalonTask | null) => void
    setIsTouchMode: (isTouchMode: boolean) => void
    setView: (view: CalendarView) => void
    setSelectedDate: (date: Date) => void
    setScheduledTasks: (tasks: HairSalonScheduledTask[]) => void
    updateTask: (task: HairSalonScheduledTask) => Promise<void>
    deleteTask: (taskId: string) => Promise<void>
    getTasksForTimeSlot: (date: string, time: string) => HairSalonScheduledTask[]
}

export const useCalendarStore = create<CalendarStore>((set, get) => ({
    scheduledTasks: [],
    unscheduledTasks: [],
    draggedTask: null,
    selectedTask: null,
    isTouchMode: false,
    view: 'day',
    selectedDate: new Date(),
    isLoading: false,

    setIsLoading: isLoading => set({ isLoading }),
    setSelectedTask: task => set({ selectedTask: task }),
    setIsTouchMode: isTouchMode => set({ isTouchMode }),
    setView: (view: CalendarView) => set({ view }),
    setSelectedDate: (date: Date) => set({ selectedDate: date }),
    setScheduledTasks: tasks => set({ scheduledTasks: tasks }),

    updateTask: async updatedTask => {
        set(state => ({
            scheduledTasks: state.scheduledTasks.map(t => (t.id === updatedTask.id ? updatedTask : t)),
        }))

        return Promise.resolve()
    },

    deleteTask: async taskId => {
        set(state => ({
            scheduledTasks: state.scheduledTasks.filter(t => t.id !== taskId),
        }))

        return Promise.resolve()
    },
    getTasksForTimeSlot: (date, time) => {
        return get().scheduledTasks.filter(t => t.date === date && t.time === time)
    },
}))
